/**
 * 基础错误在这里统一就处理了
 * @type {{}}
 */

import lang from '../../lang';
import Notice from 'c-notification';

//  外部引用的时候最好是使用常量名称对比，不要直接和值进行对比
const TIMEOUT = -1;
const REQ_ERROR = -2;

const messages = {
    [TIMEOUT]: lang.template('Session timeout.'),
    [REQ_ERROR]: lang.template('Error.'),
    4096: lang.template('Invalid data.'),
    8192: lang.template('Expired userToken.'),
    16777215: lang.template('System error.')
};

function errHandler(code) {
    messages[code] && Notice.simple(messages[code] || code);
}

export { TIMEOUT, REQ_ERROR, messages };
export default errHandler;



// WEBPACK FOOTER //
// ./js/component/api/error-handle.js